import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseSort } from '../../services';

export const fetchShowcaseSort = createAsyncThunk(
    'showcaseSort/fetchShowcaseSort',
    async ({ id, sort }) => {
        const response = await ShowcaseSort(id, sort)
        return response.result
    }
)

const showcaseSortSlice = createSlice({
    name: 'showcaseSort',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseSort.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseSort.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseSort.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseSortSlice.reducer;
